import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';
import { AuthState } from 'app/core/state/auth.state';

/**
 * Guard that allows Admin (SuperAdmin/SystemAdmin) OR Demo users
 * to access CMS Medical Data routes.
 *
 * ROLE ACCESS:
 * - SuperAdmin: ✅
 * - SystemAdmin: ✅
 * - Demo: ✅
 * - Others: ❌ → redirect to their default route
 */
export const CmsDataGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router = inject(Router);
  const authState = inject(AuthState);

  // Allow if user has admin access OR demo access
  if (authState.hasAdminAccess() || authState.hasDemoAccess()) {
    return true;
  }

  console.log('[CmsDataGuard] Access denied - redirecting to:', authState.defaultRoute());
  router.navigate([authState.defaultRoute()]);
  return false;
};
